{
  "account.add_or_remove_from_list": "ⵔⵏⵓ ⵏⵖ ⵙⵉⵜⵜⵢ ⵙⴳ ⵜⵍⴳⴰⵎⵜ",
  "account.badges.bot": "ⴰⴱⵓⵜ",
  "account.badges.group": "ⵜⴰⵔⴰⴱⴱⵓⵜ",
  "account.block": "ⴳⴷⵍ @{name}",
  "account.block_domain": "ⴳⴷⵍ ⵉⴳⵔ {domain}",
  "account.blocked": "ⵉⵜⵜⵓⴳⴷⵍ",
  "account.cancel_follow_request": "Withdraw follow request",
  "account.edit_profile": "ⵙⵏⴼⵍ ⵉⴼⵔⵙ",
  "account.follow": "ⴹⴼⵕ",
  "account.followers": "ⵉⵎⴹⴼⴰⵕⵏ",
  "account.media": "ⴰⵙⵏⵖⵎⵉⵙ",
  "account.mute": "ⵥⵥⵉⵥⵏ @{name}",
  "account.muted": "ⵉⵜⵜⵓⵥⵉⵥⵏ",
  "account.posts": "Toots",
  "account.share": "ⴱⴹⵓ ⵉⴼⵔⵙ ⵏ @{name}",
  "account.unfollow": "ⴽⴽⵙ ⴰⴹⴼⴼⵓⵕ",
  "account_note.placeholder": "Click to add a note",
  "bundle_column_error.retry": "ⴰⵍⵙ ⴰⵔⵎ",
  "bundle_modal_error.close": "ⵔⴳⵍ",
  "bundle_modal_error.retry": "ⴰⵍⵙ ⴰⵔⵎ",
  "column.blocks": "ⵉⵏⵙⵙⵎⵔⵙⵏ ⵜⵜⵓⴳⴷⵍⵏⵉⵏ",
  "column.home": "ⴰⵙⵏⵓⴱⴳ",
  "column.lists": "ⵜⵉⵍⴳⴰⵎⵉⵏ",
  "column.notifications": "ⵜⵉⵏⵖⵎⵉⵙⵉⵏ",
  "column.pins": "Pinned toot",
  "column_back_button.label": "ⴰⵖⵓⵍ",
  "column_header.hide_settings": "ⵙⵏⵜⵍ ⵜⵉⵙⵖⴰⵍ",
  "column_header.pin": "ⵖⵏⵙ",
  "column_header.show_settings": "ⵙⵎⴰⵍ ⵜⵉⵙⵖⴰⵍ",
  "column_header.unpin": "ⴽⴽⵙ ⴰⵖⵏⴰⵙ",
  "community.column_settings.local_only": "ⵖⴰⵙ ⴰⴷⵖⴰⵔⴰⵏ",
  "community.column_settings.media_only": "ⵖⴰⵙ ⵉⵙⵏⵖⵎⵉⵙⵏ",
  "compose_form.direct_message_warning_learn_more": "ⵙⵙⵏ ⵓⴳⴳⴰⵔ",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer.lock": "ⵉⵜⵜⵓⵔⴳⵍ",
  "compose_form.placeholder": "ⵎⴰⵢⴷ ⵉⵍⵍⴰⵏ ⴳ ⵉⵅⴼ ⵏⵏⴽ?",
  "compose_form.spoiler.marked": "Text is hidden behind warning",
  "compose_form.spoiler.unmarked": "Text is not hidden",
  "confirmation_modal.cancel": "ⵙⵔ",
  "confirmations.block.confirm": "ⴳⴷⵍ",
  "confirmations.delete.confirm": "ⴽⴽⵙ",
  "confirmations.delete.message": "ⵉⵙ ⵏⵉⵜ ⵜⵅⵙⴷ ⴰⴷ ⵜⴽⴽⵙⴷ ⵜⴰⵥⵕⵉⴳⵜ ⴰ?",
  "confirmations.delete_list.confirm": "ⴽⴽⵙ",
  "confirmations.logout.confirm": "ⴼⴼⵖ",
  "confirmations.logout.message": "ⵉⵙ ⵏⵉⵜ ⵜⵅⵙⴷ ⴰⴷ ⵜⴼⴼⵖⴷ?",
  "confirmations.mute.confirm": "ⵥⵥⵉⵥⵏ",
  "confirmations.unfollow.confirm": "ⴽⴽⵙ ⴰⴹⴼⴼⵓⵕ",
  "conversation.delete": "ⴽⴽⵙ ⴰⵎⵙⴰⵡⴰⵍ",
  "conversation.with": "ⴰⴽⴷ {names}",
  "embed.instructions": "Embed this status on your website by copying the code below.",
  "emoji_button.flags": "ⵉⵛⵏⵢⴰⵍⵏ",
  "emoji_button.food": "ⵓⵜⵛⵉ & ⵜⵉⵙⵙⵉ",
  "emoji_button.not_found": "ⵓⵍⴰ ⵉⵎⵓⵊⵉ!! (╯°□°）╯︵ ┻━┻",
  "emoji_button.people": "ⵎⵉⴷⴷⵏ",
  "emoji_button.search": "ⵔⵣⵓ...",
  "emoji_button.symbols": "ⵜⵉⵎⴰⵜⴰⵔⵉⵏ",
  "empty_column.account_timeline": "No toots here!",
  "empty_column.bookmarked_statuses": "You don't have any bookmarked toots yet. When you bookmark one, it will show up here.",
  "empty_column.home": "Your home timeline is empty! Follow more people to fill it up. {suggestions}",
  "empty_column.list": "There is nothing in this list yet. When members of this list post new statuses, they will appear here.",
  "follow_request.reject": "ⴰⴳⵢ",
  "hashtag.column_header.tag_mode.all": "ⴷ {additional}",
  "hashtag.column_header.tag_mode.any": "ⵏⵖ {additional}",
  "hashtag.column_settings.select.placeholder": "ⵙⴽⵛⵎ ⴰⵀⴰⵛⵟⴰⴳ…",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "intervals.full.days": "{number, plural, one {# ⵡⴰⵙⵙ} other {# ⵡⵓⵙⵙⴰⵏ}}",
  "intervals.full.minutes": "{number, plural, one {# ⵜⵓⵙⴷⵉⴷⵜ} other {# ⵜⵓⵙⴷⵉⴷⵉⵏ}}",
  "keyboard_shortcuts.back": "to navigate back",
  "keyboard_shortcuts.blocked": "to open blocked users list",
  "keyboard_shortcuts.boost": "to boost",
  "keyboard_shortcuts.column": "to focus a status in one of the columns",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.down": "to move down in the list",
  "keyboard_shortcuts.enter": "to open status",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "to open home timeline",
  "keyboard_shortcuts.legend": "to display this legend",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "to mention author",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "to open your profile",
  "keyboard_shortcuts.notifications": "to open notifications column",
  "keyboard_shortcuts.open_media": "to open media",
  "keyboard_shortcuts.pinned": "to open pinned toots list",
  "keyboard_shortcuts.profile": "to open author's profile",
  "keyboard_shortcuts.reply": "ⵉ ⵓⵔⴰⵔⵉ",
  "keyboard_shortcuts.requests": "to open follow requests list",
  "keyboard_shortcuts.search": "to focus search",
  "keyboard_shortcuts.spoilers": "to show/hide CW field",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "to show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "to show/hide media",
  "keyboard_shortcuts.toot": "to start a brand new toot",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "to move up in the list",
  "lightbox.close": "ⵔⴳⵍ",
  "lists.delete": "ⴽⴽⵙ ⵜⴰⵍⴳⴰⵎⵜ",
  "lists.edit": "ⵙⵏⴼⵍ ⵜⴰⵍⴳⴰⵎⵜ",
  "lists.replies_policy.none": "ⴰⵡⴷ ⵢⴰⵏ",
  "load_pending": "{count, plural, one {# ⵓⴼⵔⴷⵉⵙ ⴰⵎⴰⵢⵏⵓ} other {# ⵉⴼⵔⴷⴰⵙ ⵉⵎⴰⵢⵏⵓⵜⵏ}}",
  "navigation_bar.domain_blocks": "Hidden domains",
  "navigation_bar.follow_requests": "ⵜⵓⵜⵔⴰⵡⵉⵏ ⵏ ⵓⴹⴼⴰⵕ",
  "navigation_bar.lists": "ⵜⵉⵍⴳⴰⵎⵉⵏ",
  "navigation_bar.logout": "ⴼⴼⵖ",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.follow": "ⵉⴹⴼⴼⴰⵔ ⴽ {name}",
  "notification.reblog": "{name} boosted your status",
  "notifications.clear": "ⵙⴼⴹ ⵜⵉⵏⵖⵎⵉⵙⵉⵏ",
  "notifications.column_settings.sound": "ⵖⵔ ⵉⵎⵙⵍⵉ",
  "notifications.column_settings.status": "New toots:",
  "notifications.filter.all": "ⴰⴽⴽⵯ",
  "notifications.group": "{count} ⵜⵏⵖⵎⵉⵙⵉⵏ",
  "poll.closed": "ⵉⵜⵜⵓⵔⴳⵍ",
  "poll.total_people": "{count, plural, one {# ⵓⴼⴳⴰⵏ} other {# ⵉⴼⴳⴰⵏⵏ}}",
  "poll.total_votes": "{count, plural, one {# ⵓⵙⵜⵜⴰⵢ} other {# ⵉⵙⵜⵜⴰⵢⵏ}}",
  "poll_button.add_poll": "ⵔⵏⵓ ⵢⴰⵏ ⵢⵉⴷⵣ",
  "poll_button.remove_poll": "ⵙⵙⵉⵜⵢ ⵉⴷⵣ",
  "privacy.change": "Adjust status privacy",
  "privacy.public.short": "ⵜⴰⴳⴷⵓⴷⴰⵏⵜ",
  "relative_time.days": "{number}ⴰⵙ",
  "relative_time.hours": "{number}ⵙⵔⴳ",
  "relative_time.just_now": "ⴷⵖⵉ",
  "relative_time.minutes": "{number}ⵙⴷ",
  "relative_time.seconds": "{number}ⵙⵏ",
  "relative_time.today": "ⴰⵙⵙⴰ",
  "reply_indicator.cancel": "ⵙⵔ",
  "report.forward": "ⵙⵙⵉⴼⴹ ⵉ {target}",
  "report.placeholder": "Type or paste additional comments",
  "report.submit": "ⴰⵣⵏ",
  "report.target": "Report {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "search.placeholder": "ⵔⵣⵓ",
  "search_results.hashtags": "ⵀⴰⵛⵟⴰⴳ",
  "search_results.statuses": "Toots",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_status": "Open this status in the moderation interface",
  "status.block": "ⴳⴷⵍ @{name}",
  "status.copy": "Copy link to status",
  "status.delete": "ⴽⴽⵙ",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.load_more": "ⵙⵙⵉⵍⵉ ⵓⴳⴳⴰⵔ",
  "status.more": "ⵓⴳⴳⴰⵔ",
  "status.mute": "ⵥⵥⵉⵥⵏ @{name}",
  "status.mute_conversation": "ⵥⵥⵉⵥⵏ ⴰⵎⵙⴰⵡⴰⵍ",
  "status.open": "Expand this status",
  "status.read_more": "ⵖⵔ ⵓⴳⴳⴰⵔ",
  "status.reblogs.empty": "No one has boosted this toot yet. When someone does, they will show up here.",
  "status.reply": "ⵔⴰⵔ",
  "status.share": "ⴱⴹⵓ",
  "status.show_less_all": "ⵙⵎⴰⵍ ⴷⵔⵓⵙ ⵉ ⵎⴰⵕⵕⴰ",
  "status.show_more_all": "ⵙⵎⴰⵍ ⵓⴳⴳⴰⵔ ⵉ ⵎⴰⵕⵕⴰ",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "tabs_bar.home": "ⴰⵙⵏⵓⴱⴳ",
  "tabs_bar.notifications": "ⵜⵉⵏⵖⵎⵉⵙⵉⵏ",
  "time_remaining.days": "{number, plural, one {# ⵡⴰⵙⵙ} other {# ⵡⵓⵙⵙⴰⵏ}} ⵉⵇⵇⵉⵎⵏ",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "upload_button.label": "ⵔⵏⵓ ⵜⴰⵡⵍⴰⴼⵜ, ⴰⴼⵉⴷⵢⵓ ⵏⵖ ⴰⴼⴰⵢⵍⵓ ⵙ ⵉⵎⵙⵍⵉ",
  "upload_form.edit": "ⵙⵏⴼⵍ",
  "upload_progress.label": "Uploading…",
  "video.close": "ⵔⴳⵍ ⴰⴼⵉⴷⵢⵓ",
  "video.download": "ⴰⴳⵎ ⴰⴼⴰⵢⵍⵓ",
  "video.hide": "ⴼⴼⵔ ⴰⴼⵉⴷⵢⵓ",
  "video.pause": "ⵙⴱⴷⴷ",
  "video.play": "ⵖⵔ"
}
